import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import { useCategory } from '~/composables/_next/useCategory';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useProduct } from '~/composables/_next/useProduct';
import { useUser } from '~/composables/_next/useUser';
import { PageTypes } from '~/types/PageTypes';
import { useLocalization } from '~/composables/_next/useLocalization';
import useRightPath from '~/composables/useRightPath';
import { DUMBSLUG_PREFIX } from '~/i18n.config';
import { LocalRouteNames, ContentfulRouteNames, DEFAULT_EODP_FR_URL_PARAMETER } from '~/constants/RoutesEnums';
import { klaviyoProfileUpdateEvent } from '~/helpers/tracking/klaviyo';
export function useLocaleSwitcher() {
  // ------------- GLOBALS ---------------- //
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app,
    $sentry = _useNuxt2App.$sentry;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var route = useRoute();
  var router = useRouter();
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    defaultLocale = _useLocalization.defaultLocale;
  var _useCategory = useCategory('categoryLanguage'),
    searchCategory = _useCategory.search,
    categories = _useCategory.categories;
  var _useProduct = useProduct('localeSwitcher-products'),
    searchProduct = _useProduct.search,
    products = _useProduct.products;
  var _useCntfContent = useCntfContent('currentPageCheck'),
    search = _useCntfContent.search,
    content = _useCntfContent.content;
  var _useUser = useUser(),
    currentUser = _useUser.user,
    updateUser = _useUser.update;
  var isLocalizationUpdating = ref(false);
  function handleLoadingUpdate(newValue) {
    isLocalizationUpdating.value = newValue;
  }

  // ------------- COUNTRY ---------------- //
  var _useShippingCountry = useShippingCountry(),
    setShippingCountry = _useShippingCountry.setShippingCountry,
    currentCountry = _useShippingCountry.country;
  var _useCart = useCart(),
    updateShippingAddress = _useCart.updateShippingAddress;
  function changeCountry(_x) {
    return _changeCountry.apply(this, arguments);
  } // ------------- LOCALE ---------------- //
  function _changeCountry() {
    _changeCountry = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(country) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(country !== currentCountry.value)) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return updateShippingAddress({
              country: country
            });
          case 3:
            setShippingCountry(country, true);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _changeCountry.apply(this, arguments);
  }
  var localizedUrl = ref('');
  var surveySlug = useState('generic-survey-slug', function () {
    return null;
  });
  var _useRightPath = useRightPath(),
    getPagePath = _useRightPath.getPagePath,
    getContentType = _useRightPath.getContentType;
  function resetUrlToDefault() {
    localizedUrl.value = '';
  }

  // REFACTOR: refactor needed (SRP, complexity)
  function selectLocale(_x2) {
    return _selectLocale.apply(this, arguments);
  }
  function _selectLocale() {
    _selectLocale = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(selectedLocale) {
      var _route$name, currentRouteName, paramsSlug, switchLocalePath, isSelectedLocaleDefault, contentType, getContentfulTranslatedSlug, newSlugFromCtf, _surveySlug$value, _surveySlug$value$dat, _surveySlug$value$dat2, slugs, slug, _surveySlug$value2, _surveySlug$value2$da, _surveySlug$value2$da2, _slugs, _slug, _categories$value, _categories$value$, _categories$value$$_a, newSlugFromCtCategories, guideTranslatedSlug, _guideTranslatedSlug, _products$value, _products$value$, _products$value$$_ori, _products$value$$_ori2, _products$value$$_ori3, newSlugFromCt;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            isLocalizationUpdating.value = true;
            localizedUrl.value = '/';

            // Because slugs are translated and stored either in CommerceTools, Contentful or locally
            // depending on page type, in order to change locale we need to determine first
            // on what page type we are and based on that change locale and URL
            _route$name = route.name, currentRouteName = _route$name === void 0 ? '' : _route$name;
            paramsSlug = route.params.slug || route.params.slug_1;
            switchLocalePath = app.switchLocalePath(selectedLocale.code);
            isSelectedLocaleDefault = defaultLocale === selectedLocale.code;
            contentType = getContentType(route.path); // Fix bug where currentRouteName unexpectedly returns null when switching languages
            if (currentRouteName) {
              _context3.next = 10;
              break;
            }
            isLocalizationUpdating.value = false;
            return _context3.abrupt("return");
          case 10:
            // If it is page routed only in VSF, we can just use switchLocalePath from i18n
            if (Object.values(LocalRouteNames).some(function (routeName) {
              return currentRouteName.includes(routeName);
            })) {
              localizedUrl.value = switchLocalePath;
            }

            // If page slug is stored in Contentful (and therefore translatable)
            // we need to determine what CTF page we are on and make
            // a request to CTF to get the proper translated slug
            getContentfulTranslatedSlug = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _currentPageContent$f, _currentPageContent$f2;
                var _ref2,
                  _ref2$queryParams,
                  queryParams,
                  _ref2$contentType,
                  contentType,
                  query,
                  pageTypeContent,
                  currentPageContent,
                  localizedSlug,
                  _args2 = arguments;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$queryParams = _ref2.queryParams, queryParams = _ref2$queryParams === void 0 ? '' : _ref2$queryParams, _ref2$contentType = _ref2.contentType, contentType = _ref2$contentType === void 0 ? '' : _ref2$contentType;
                      query = {
                        locale: '*',
                        query: paramsSlug,
                        select: ['sys.id', 'sys.contentType', 'fields.slug']
                      };
                      if (contentType) query.content_type = contentType;
                      _context2.next = 5;
                      return search(query);
                    case 5:
                      pageTypeContent = content.value.filter(function (item) {
                        return item.sys.contentType.sys.id.includes('page');
                      });
                      currentPageContent = pageTypeContent.find(function (page) {
                        var _page$fields, _page$fields$slug;
                        return ((_page$fields = page.fields) === null || _page$fields === void 0 ? void 0 : (_page$fields$slug = _page$fields.slug) === null || _page$fields$slug === void 0 ? void 0 : _page$fields$slug[locale]) === paramsSlug + queryParams;
                      });
                      localizedSlug = currentPageContent === null || currentPageContent === void 0 ? void 0 : (_currentPageContent$f = currentPageContent.fields) === null || _currentPageContent$f === void 0 ? void 0 : (_currentPageContent$f2 = _currentPageContent$f.slug) === null || _currentPageContent$f2 === void 0 ? void 0 : _currentPageContent$f2[selectedLocale.code];
                      if (!(localizedSlug && localizedSlug.startsWith(DUMBSLUG_PREFIX))) {
                        _context2.next = 10;
                        break;
                      }
                      return _context2.abrupt("return", null);
                    case 10:
                      return _context2.abrupt("return", localizedSlug);
                    case 11:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function getContentfulTranslatedSlug() {
                return _ref.apply(this, arguments);
              };
            }();
            if (!Object.values(ContentfulRouteNames).some(function (routeName) {
              return currentRouteName.includes(routeName);
            })) {
              _context3.next = 17;
              break;
            }
            _context3.next = 15;
            return getContentfulTranslatedSlug({
              contentType: contentType
            });
          case 15:
            newSlugFromCtf = _context3.sent;
            localizedUrl.value = newSlugFromCtf ? replaceSlug(switchLocalePath, newSlugFromCtf) : '/';
          case 17:
            // If page is stored in Contentful but slug is locally hardcoded and different for FR
            if (currentRouteName.includes('guides')) {
              localizedUrl.value = getPagePath(PageTypes.EOLP, selectedLocale.code);
            }
            if (currentRouteName.includes('legacy-AllProducts')) {
              localizedUrl.value = getPagePath(PageTypes.ALL, selectedLocale.code);
            }
            if (currentRouteName.includes('all-advices')) {
              localizedUrl.value = getPagePath(PageTypes.CUSTOM_ALL_ADVICES, selectedLocale.code);
            }
            if (currentRouteName.includes('legacy-Survey-Survey')) {
              localizedUrl.value = getPagePath(PageTypes.SUR, selectedLocale.code);
            }
            if (currentRouteName.includes('legacy-Survey-SurveyResult')) {
              localizedUrl.value = getPagePath(PageTypes.SRE, selectedLocale.code);
            }
            if (!(currentRouteName.includes('legacy-Survey-slug') || currentRouteName.includes('legacy-SurveyResult-slug'))) {
              _context3.next = 28;
              break;
            }
            _context3.next = 25;
            return client.contentful.getSurveyGeneric.query({
              locale: locale,
              slug: paramsSlug
            });
          case 25:
            surveySlug.value = _context3.sent;
            if (currentRouteName.includes('legacy-Survey-slug')) {
              slugs = (_surveySlug$value = surveySlug.value) === null || _surveySlug$value === void 0 ? void 0 : (_surveySlug$value$dat = _surveySlug$value.data) === null || _surveySlug$value$dat === void 0 ? void 0 : (_surveySlug$value$dat2 = _surveySlug$value$dat.surveyGenericTemplateCollection) === null || _surveySlug$value$dat2 === void 0 ? void 0 : _surveySlug$value$dat2.items[0];
              slug = slugs['slug' + selectedLocale.code.toUpperCase()];
              localizedUrl.value = getPagePath(PageTypes.GSUR, selectedLocale.code, {
                slug: slug
              });
            }
            if (currentRouteName.includes('legacy-SurveyResult-slug')) {
              _slugs = (_surveySlug$value2 = surveySlug.value) === null || _surveySlug$value2 === void 0 ? void 0 : (_surveySlug$value2$da = _surveySlug$value2.data) === null || _surveySlug$value2$da === void 0 ? void 0 : (_surveySlug$value2$da2 = _surveySlug$value2$da.surveyGenericTemplateCollection) === null || _surveySlug$value2$da2 === void 0 ? void 0 : _surveySlug$value2$da2.items[0];
              _slug = _slugs['slug' + selectedLocale.code.toUpperCase()];
              localizedUrl.value = getPagePath(PageTypes.GSRE, selectedLocale.code, {
                slug: _slug
              });
            }
          case 28:
            if (currentRouteName.includes('legacy-FAQ-ContactForm')) {
              localizedUrl.value = getPagePath(PageTypes.CONTACT, selectedLocale.code);
            }

            // If we are on product listing page which is using category data from CommerceTools
            // We need to find translated category name, custom query was needed
            // because data about category name translations was missing from original response
            if (!currentRouteName.includes('products-slug')) {
              _context3.next = 34;
              break;
            }
            _context3.next = 32;
            return searchCategory({
              slug: paramsSlug,
              perPage: 1
            });
          case 32:
            newSlugFromCtCategories = (_categories$value = categories.value) === null || _categories$value === void 0 ? void 0 : (_categories$value$ = _categories$value[0]) === null || _categories$value$ === void 0 ? void 0 : (_categories$value$$_a = _categories$value$._allSlugs) === null || _categories$value$$_a === void 0 ? void 0 : _categories$value$$_a[selectedLocale.code];
            localizedUrl.value = newSlugFromCtCategories ? replaceSlug(switchLocalePath, newSlugFromCtCategories) : '/';
          case 34:
            if (!currentRouteName.includes('guide-slug')) {
              _context3.next = 40;
              break;
            }
            if (!isSelectedLocaleDefault) {
              _context3.next = 40;
              break;
            }
            _context3.next = 38;
            return getContentfulTranslatedSlug();
          case 38:
            guideTranslatedSlug = _context3.sent;
            localizedUrl.value = getPagePath(PageTypes.EODP, selectedLocale.code, {
              slug: guideTranslatedSlug
            });
          case 40:
            if (!(currentRouteName.includes('product-slug') && route.query.page === 'library')) {
              _context3.next = 45;
              break;
            }
            _context3.next = 43;
            return getContentfulTranslatedSlug({
              queryParams: DEFAULT_EODP_FR_URL_PARAMETER
            });
          case 43:
            _guideTranslatedSlug = _context3.sent;
            localizedUrl.value = _guideTranslatedSlug ? getPagePath(PageTypes.EODP, selectedLocale.code, {
              slug: _guideTranslatedSlug
            }) : '/';
          case 45:
            if (!(currentRouteName.includes('product-slug') && !(route.query.page === 'library'))) {
              _context3.next = 50;
              break;
            }
            _context3.next = 48;
            return searchProduct({
              slug: paramsSlug
            });
          case 48:
            newSlugFromCt = (_products$value = products.value) === null || _products$value === void 0 ? void 0 : (_products$value$ = _products$value[0]) === null || _products$value$ === void 0 ? void 0 : (_products$value$$_ori = _products$value$._original) === null || _products$value$$_ori === void 0 ? void 0 : (_products$value$$_ori2 = _products$value$$_ori.masterData) === null || _products$value$$_ori2 === void 0 ? void 0 : (_products$value$$_ori3 = _products$value$$_ori2.current) === null || _products$value$$_ori3 === void 0 ? void 0 : _products$value$$_ori3["slug_".concat(selectedLocale.code)];
            if (newSlugFromCt) {
              localizedUrl.value = replaceSlug(switchLocalePath, newSlugFromCt);
              if (isSelectedLocaleDefault) {
                localizedUrl.value = localizedUrl.value.replace('product', 'info/fiche-technique');
              } else {
                localizedUrl.value = localizedUrl.value.replace('info/fiche-technique', 'product');
              }
            } else {
              localizedUrl.value = '/';
            }
          case 50:
            isLocalizationUpdating.value = false;
          case 51:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _selectLocale.apply(this, arguments);
  }
  function changeLocale(_x3) {
    return _changeLocale.apply(this, arguments);
  } // ------------- LOCALIZATION ---------------- //
  function _changeLocale() {
    _changeLocale = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(selectedLocale) {
      var _currentUser$value, _currentUser$value2, _currentUser$value3;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!currentUser.value) {
              _context4.next = 15;
              break;
            }
            _context4.next = 3;
            return updateUser({
              locale: selectedLocale.code
            });
          case 3:
            _context4.prev = 3;
            if (!(currentUser !== null && currentUser !== void 0 && (_currentUser$value = currentUser.value) !== null && _currentUser$value !== void 0 && _currentUser$value.email)) {
              _context4.next = 7;
              break;
            }
            _context4.next = 7;
            return klaviyoProfileUpdateEvent(currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$value2 = currentUser.value) === null || _currentUser$value2 === void 0 ? void 0 : _currentUser$value2.email, selectedLocale.code);
          case 7:
            _context4.next = 15;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('email', currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$value3 = currentUser.value) === null || _currentUser$value3 === void 0 ? void 0 : _currentUser$value3.email);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('locale', locale);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('error', _context4.t0);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('Klaviyo profile update on login failed'));
          case 15:
            if (localizedUrl.value === '/' && defaultLocale !== selectedLocale.code) {
              router.push({
                path: "/".concat(selectedLocale.code)
              });
            } else {
              location.assign(localizedUrl.value);
            }
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 9]]);
    }));
    return _changeLocale.apply(this, arguments);
  }
  function updateLocalization(_x4, _x5) {
    return _updateLocalization.apply(this, arguments);
  }
  function _updateLocalization() {
    _updateLocalization = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(country, locale) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return changeCountry(country);
          case 2:
            _context5.next = 4;
            return changeLocale(locale);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _updateLocalization.apply(this, arguments);
  }
  return {
    isLocalizationUpdating: isLocalizationUpdating,
    currentCountry: currentCountry,
    localizedUrl: localizedUrl,
    handleLoadingUpdate: handleLoadingUpdate,
    resetUrlToDefault: resetUrlToDefault,
    selectLocale: selectLocale,
    updateLocalization: updateLocalization
  };
}
function replaceSlug(url, newString) {
  if (!newString) return url;
  var urlArr = url.split('/');
  urlArr[urlArr.length - 1] = newString;
  url = urlArr.join('/');
  return url;
}